import { ZoneState } from './types';

const state = (): ZoneState => {
  return {
    zones: [],
  };
};

export default state;
